export interface IEnvironment {
	production: boolean
	environment: EEnvironment
	apiUrl: string
	signinRedirectUrl: string
	geolocationByIpApiUrl: string
	geolocationByIpApiKey: string
}

export enum EEnvironment {
	prod = 'prod',
	test = 'test',
	dev = 'dev',
	local = 'local',
}
